import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import type { IFavorite } from '@/common/interfaces/favorite.interface';
import { API_SERVER_URL, V3_APP_BASE_URL } from '@/constants/Config';

export const favoriteQuery = createApi({
  reducerPath: 'favoriteQuery',
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  tagTypes: ['FavoritedDesign', 'FavoritedProduct'],
  endpoints: (build) => ({
    getFavorite: build.query({
      query: ({ fetchDesign, limit }) => ({
        url: `api/cp/favorite?limit=${limit}${fetchDesign ? '&fetchDesign=true' : ''}`,
        method: 'get',
      }),
      providesTags: (_result, _error, { fetchDesign }) =>
        fetchDesign ? ['FavoritedDesign'] : ['FavoritedProduct'],
      transformResponse: (response: { favorites: IFavorite[] }) => response.favorites,
    }),
    getFavoriteApiServer: build.query({
      query: ({ fetchDesign, limit }) => ({
        url: `${API_SERVER_URL}api/favorite/hq?limit=${limit}${
          fetchDesign ? '&fetchDesign=true' : ''
        }`,
        method: 'get',
      }),
      providesTags: (_result, _error, { fetchDesign }) =>
        fetchDesign ? ['FavoritedDesign'] : ['FavoritedProduct'],
      transformResponse: (response: { favorites: IFavorite[] }) => response?.favorites,
    }),
    removeFavorite: build.mutation({
      query: ({ data }) => ({
        url: `api/fp/favorite/removeFavorite`,
        method: 'POST',
        data: { ...data },
      }),
      invalidatesTags: (_result, _error, { data }) =>
        data.is_design ? ['FavoritedDesign'] : ['FavoritedProduct'],
    }),
    removeFavoriteApiServer: build.mutation({
      query: ({ data }) => ({
        url: `${API_SERVER_URL}api/favorite/hq/removeFavorite`,
        method: 'POST',
        data: { ...data },
      }),
      invalidatesTags: (_result, _error, { data }) =>
        data.is_design ? ['FavoritedDesign'] : ['FavoritedProduct'],
    }),
    addFavorite: build.mutation({
      query: ({ data }) => ({
        url: `api/fp/favorite/addFavorites`,
        method: 'POST',
        data: { ...data },
      }),
      invalidatesTags: (_result, _error, { data }) =>
        data.is_design ? ['FavoritedDesign'] : ['FavoritedProduct'],
    }),
  }),
});

export const {
  useGetFavoriteQuery,
  useRemoveFavoriteMutation,
  useAddFavoriteMutation,
  useGetFavoriteApiServerQuery,
  useRemoveFavoriteApiServerMutation,
} = favoriteQuery;
